<template>
    <div class="container">
        <div id="dd-container">
        <a href="https://doublethedonation.com/matching-grant-resources/matching-gift-basics/">Matching Gift</a> and
        <a href="https://doublethedonation.com/matching-grant-resources/volunteer-grant-basics/">Volunteer Grant</a> information provided by
        <a href="https://doublethedonation.com">
            <img alt="Powered by Double the Donation" src="https://doublethedonation.com/api/img/powered-by.png" />
        </a>
        </div>
    </div>
</template>
  
<script>
import mixin from '@/utils/mixin.js'

export default {
  name: 'DoubleTheDonationFeaturedSection',
  mixins: [mixin],
  data() {
    return {
      ddconfScript: null,
      ddPluginScript: null
    }
  },
  mounted() {
    const hasReloadedFromStorage = sessionStorage.getItem('hasDoubleTheDonationReloaded');
    if (hasReloadedFromStorage === 'false') {
      this.reloadPage()
    } else if(!this.checkNullAndEmptyValues(hasReloadedFromStorage)) {
      this.loadScript()
      this.reloadPage()
    } else {
      this.loadScript()
    }
  },
  methods: {
    reloadPage() {
      location.reload();
      sessionStorage.setItem('hasDoubleTheDonationReloaded', true);
    },
    loadScript() {
      // Create and append ddconfScript
      this.ddconfScript = document.createElement('script');
      this.ddconfScript.innerHTML = 'var DDCONF = { API_KEY: "kgDVg2oDdSU4H75l" };';
      document.head.appendChild(this.ddconfScript);
  
      // Create and append ddPluginScript
      this.ddPluginScript = document.createElement('script');
      this.ddPluginScript.src = 'https://doublethedonation.com/api/js/ddplugin.js';
      this.ddPluginScript.async = true;
      document.head.appendChild(this.ddPluginScript);
    }
  },
  beforeDestroy() {
    // Clean up scripts when the component is destroyed
    if (this.ddconfScript) {
      this.ddconfScript.parentNode.removeChild(this.ddconfScript);
    }
    if (this.ddPluginScript) {
      this.ddPluginScript.parentNode.removeChild(this.ddPluginScript);
    }
    sessionStorage.setItem('hasDoubleTheDonationReloaded', false);
  }
}
</script>
  